var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
      _c(
        "div",
        { staticClass: "nk-block-between align-items-start" },
        [
          _c("div", { staticClass: "nk-block-head-content" }, [
            _c("h3", { staticClass: "nk-block-title page-title" }, [
              _vm._v(_vm._s(_vm.trans("permission.assign_permission"))),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
              attrs: { to: "/configuration/permission" },
            },
            [_vm._v(_vm._s(_vm.trans("general.back")))]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "admin-config-layout admin-linear-page" },
      [
        _c("configuration-sidebar", { attrs: { menu: "permission" } }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-config-panel" }, [
          _c(
            "div",
            {
              staticClass:
                "admin-config-panel__inner admin-config-panel__inner--wide",
            },
            [
              _c("div", { staticClass: "admin-linear-stats" }, [
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.trans("role.role")))]),
                  _vm._v(" "),
                  _c("strong", [_vm._v(_vm._s(_vm.roles.length))]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", [
                    _vm._v(_vm._s(_vm.trans("permission.permission"))),
                  ]),
                  _vm._v(" "),
                  _c("strong", [_vm._v(_vm._s(_vm.permissions.length))]),
                ]),
              ]),
              _vm._v(" "),
              _c("show-tip", {
                attrs: { module: "permission", tip: "tip_assign_permission" },
              }),
              _vm._v(" "),
              _c(
                "section",
                {
                  staticClass:
                    "admin-config-section admin-linear-matrix-section mt-3",
                  attrs: {
                    "aria-label": _vm.trans("permission.assign_permission"),
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "admin-list-table-card admin-config-list-card",
                    },
                    [
                      _c("div", { staticClass: "table-responsive" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table admin-data-table admin-data-table--config-list admin-linear-matrix-table mb-0",
                          },
                          [
                            _c("thead", [
                              _c(
                                "tr",
                                [
                                  _c("th", { attrs: { scope: "col" } }, [
                                    _vm._v(
                                      _vm._s(_vm.trans("permission.permission"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.roles, function (role) {
                                    return _c(
                                      "th",
                                      {
                                        key: role.id,
                                        staticClass: "text-center",
                                        attrs: { scope: "col" },
                                      },
                                      [_vm._v(_vm._s(role.name))]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.permissions, function (permission) {
                                return _c(
                                  "tr",
                                  { key: permission.id },
                                  [
                                    _c("td", [
                                      _c(
                                        "strong",
                                        { staticClass: "admin-linear-primary" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.toWord(permission.name))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "admin-linear-muted" },
                                        [_vm._v(_vm._s(permission.name))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.roles, function (role) {
                                      return _c(
                                        "td",
                                        {
                                          key: role.id,
                                          staticClass: "text-center",
                                        },
                                        [
                                          _c("switches", {
                                            attrs: {
                                              theme: "bootstrap",
                                              color: "success",
                                            },
                                            model: {
                                              value:
                                                _vm.assignPermissionForm.data[
                                                  role.id
                                                ][permission.id],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.assignPermissionForm.data[
                                                    role.id
                                                  ],
                                                  permission.id,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "assignPermissionForm.data[role.id][permission.id]",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                  ],
                                  2
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "admin-config-actions" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                          attrs: { type: "button" },
                          on: { click: _vm.savePermission },
                        },
                        [_vm._v(_vm._s(_vm.trans("general.save")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                          attrs: { to: "/configuration/permission" },
                        },
                        [_vm._v(_vm._s(_vm.trans("general.back")))]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nk-block-des text-soft" }, [
      _c("p", [
        _vm._v(
          "Toggle capabilities by role and save the matrix once after review."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }